import { Route } from '@angular/router';

export const CompoundsRoute: Route = {
  path: 'compounds',
  loadComponent() {
    return import('@daas-consulting/production/shared/frontend/pages').then(
      (c) => c.LayoutBase2PageComponent
    );
  },
  loadChildren() {
    return import(
      '@daas-consulting/production/shared/frontend/compounds_shell'
    ).then((c) => c.CompoundsShellRoutes);
  },
};
